import { rgb } from '../helpers';
import { LIGHT_GREY } from '../theme/color';

export const overrides = {
    MuiBreadcrumbs: {
        separator: {
            '& path': {
                fill: `rgba(${rgb(LIGHT_GREY)}, .6)`
            }
        }
    }
};
